export default "__VITE_ASSET__BxhBD3HA__"